import logo from './logo.svg';
import './App.css';
import Fiverr from './Component/Fiverr';

function App() {
  return (
    <div className="App">
    <Fiverr/>  
    
    </div>
  );
}

export default App;
